var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EB526E7B-1322-4298-AF7C-45A8386C6050") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-My-Account-Dropdown",
    transform: "translate(-1672.000000, -183.000000)",
    stroke: "#023B93",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1652.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(21.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52976415,1.45 C2.10976415,2.39 1.02976415,3.77 0.459764151,5.37 C-0.110235849,6.97 -0.150235849,8.72 0.339764151,10.35 C0.839764151,11.98 1.84976415,13.4 3.22976415,14.41 C4.59976415,15.42 6.26976415,15.95 7.96976415,15.94 C9.66976415,15.96 11.3397642,15.42 12.7097642,14.41 C14.0797642,13.4 15.0997642,11.98 15.5997642,10.35 C16.0997642,8.72 16.0597642,6.98 15.4797642,5.37 C14.9097642,3.77 13.8297642,2.39 12.4097642,1.45",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.96976415,
    y1: 9.09494702e-13,
    x2: 7.96976415,
    y2: 7.97,
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.490be865b9880eb3e5e627c745487a77.svg";
export { ForwardRef as ReactComponent };